module.exports = __webpack_public_path__ + "static/img/img-4-1.f0e4923.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-1.png
// module id = C+pv
// module chunks = 0